namespace TabAurous.Common {
    export enum CalculateTo {
        Labor = 1,
        Fancy = 2,
        Other = 3
    }
    Serenity.Decorators.registerEnumType(CalculateTo, 'TabAurous.Common.CalculateTo', 'Administration.ProcessCalculateTo');
}
